import { createSelector } from 'reselect';
import { breadcrumbSelector } from '../../workspace/breadcrumbs/breadcrumbSelector';
import { getElements } from '../utils/elementStoreUtils';
import { getElement } from '../../../common/elements/utils/elementTraversalUtils';
import { getPhysicalId } from '../../../common/elements/utils/elementPropertyUtils';
import { getIsBoardShared } from '../board/boardUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { Tag, TagMap } from '../../../common/tags/tagTypes';

type TagPath = ImMNElement[];

export const selectTags = (state: Immutable.Map<string, unknown>) => state.get('tags') as TagMap | undefined;

export const selectTagsByIds =
    (tagIds?: string[]) =>
    (state: Immutable.Map<string, object>): Tag[] => {
        if (!tagIds || tagIds.length === 0) return [];

        const allTags = selectTags(state) || {};
        return tagIds.map((tagId: string) => allTags[tagId]).filter(Boolean);
    };

export const selectTagPaths = createSelector(breadcrumbSelector, getElements, (breadcrumbs, elements) => {
    const userRootPath: ImMNElement[] =
        breadcrumbs.path?.map((elementId) => {
            const element = getElement(elements, elementId);
            return getElement(elements, getPhysicalId(element));
        }) || [];

    let hasFoundSharedBoard = false;
    const shareRootPath: ImMNElement[] = [...userRootPath].reverse().reduce((acc: TagPath, board: ImMNElement) => {
        if (hasFoundSharedBoard) return acc;

        if (getIsBoardShared(board)) hasFoundSharedBoard = true;

        acc.push(board);
        return acc;
    }, []);
    shareRootPath.reverse();

    return { userRootPath, shareRootPath };
});
